module.exports = __webpack_public_path__ + "media/virtualStaging/galleryImage8-1c025731.jpeg";